import { useQuery } from "@tanstack/react-query";

import { analysesSummaryQueryOptions } from "./analysesSummaryQueryOptions";

// Последние готовые разборы вместе: привычки по кодам находок, кто убивал чаще, средние
// метрики. Обновляется по событию `analysis.done`.
export const useAnalysesSummary = () => useQuery(analysesSummaryQueryOptions());
